const phanloaiKhachHang =[
    {
        "name": "",
        "value": ""
    },
    {
        "name": "Khách Hàng",
        "value": "KH"
    },
    {
        "name": "Trình Dược Viên",
        "value": "TDV"
    },
    {
        "name": "Không rõ",
        "value": "KR"
    }
];


const kenh_array = [
    {
        "name": "",
        "value": ""
    },
    {
        "name": "OTC",
        "value": "OTC"
    },
    {
        "name": "WSH",
        "value": "WSH"
    },
    {
        "name": "ETC",
        "value": "ETC"
    },
    {
        "name": "FMCG",
        "value": "FMCG"
    }
]
// export default phanloaiKhachHang;
export {kenh_array,phanloaiKhachHang};